const { ELYXCentralStore } = require("./ELYXStore");
const { getKeyForBrowser } = require("../utilities/Helpers");

const ELYXEventListener = {
  initELYXGlobalEventListener() {
    window.addEventListener("keydown", handleGlobalKeyPresses);
    window.addEventListener("click", handleGlobalClicks);
  },
  stopELYXGlobalEventListener() {
    window.removeEventListener("keydown", handleGlobalKeyPresses);
    window.removeEventListener("click", handleGlobalClicks);
  },
};

const registeredDropdowns = ["ELYXDropdown"];

async function handleGlobalClicks(event) {
  const element = event.target;

  /** Close any currently active dropdown in case clicked outside of it. */
  if (element && element.closest && !registeredDropdowns.some((className) => element.closest(`.${className}`))) {
    ELYXCentralStore.methods.disableActiveDropdown();
  }
}

function handleGlobalKeyPresses(event) {
  const key = getKeyForBrowser(event);
  if (!key) return;

  /** Handle escapes */
  if (key === 27) {
    /** Close any currently open dropdown */
    ELYXCentralStore.methods.disableActiveDropdown();
  }
}

/**
 * One way of solving the problem is...
 * Have a global event listener.
 *
 * And then what you do is you have a global event listener that listens for clicks.
 * And you can register on-the-fly event listeners for specific elements.
 * This way, you can keep things more self-contained within components.
 *
 * Ways to solve it:
 * 1. Global event listener and specify and manage all elements and actions inside it.
 * 2. Global event listener that simplfy registers and uses an abstraction to handle click actions and other actions,
 * but you register the actual events in the relevant components.
 *
 *
 * Pros of nr1:
 * - Manage all in one place
 *
 * Cons of nr1:
 * - No oversight or overview of what happens from within the components themselves (hidden logic), so perhaps best to have the abstraction & declare something inside a componentn
 *
 * Pros of nr2:
 * - Clear what is happening to everything related to a particular component
 *
 * Cons of nr2:
 * - More code and more places to manage the code
 *
 *
 * User clicks on dropdown button and now a dropdown must open.
 * There is a function linked to the click. That touches upon the ELYXStore functionality.
 * This could be also added into ELYXDropdownManager.js
 * This will now open the dropdown by setting the state in the ELYXStore.
 *
 * Now, next step is managing closing the dropdown.
 * This can be done in three ways:
 * 1. By clicking outside the dropdown
 * 2. By clicking on the dropdown button again
 * 3. By clicking on a dropdown item
 *
 *
 * Per dropdown, there are elements you want to also lead to closing; and other elements you don't want to lead to closing.
 * So this requires an array of allowed elements.
 *
 * There is also the 'esc' key, which should close the dropdown.
 *
 *
 */

module.exports = ELYXEventListener;
